<script setup lang="ts">
import { computed } from 'vue'

// Define props with a more descriptive name to avoid conflict
const toggleProps = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})

// Define emits
const emit = defineEmits(['update:modelValue'])

// Computed property to access the modelValue safely
const isChecked = computed(() => toggleProps.modelValue)

// Toggle function
function handleToggle() {
  emit('update:modelValue', !toggleProps.modelValue)
}
</script>

<template>
  <label class="inline-flex items-center cursor-pointer mt-1">
    <input type="checkbox" :checked="isChecked" @change="handleToggle" class="toggle-checkbox peer" />
    <div
      class="relative w-9 h-5 rounded-full peer bg-gray-700 peer-checked:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-blue-500 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white peer-checked:after:bg-blue-500 after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600"
    ></div>
  </label>
</template>

<style scoped>
.toggle-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}
</style>
